import { CreditCard, Plus, X } from 'lucide-react';

import {
    Button,
    PageDialog,
    PageDialogClose,
    PageDialogContent,
    PageDialogHeader,
    PageDialogTitle,
    Sheet,
    SheetClose,
    SheetContent,
    SheetHeader,
    SheetTrigger,
} from '@codes/ui-kit';

export const WorkspacePage = () => {
    return (
        // TODO: 카드 모달
        <PageDialog open={true}>
            <PageDialogContent>
                <div className="w-full max-w-[500px] sm:pt-[56px] sm:pb-[34px]">
                    <PageDialogHeader>
                        <PageDialogTitle>Add Payment Method</PageDialogTitle>
                        <PageDialogClose asChild>
                            <button className="absolute right-6 top-[19px] z-[51]" type="button">
                                <X className="w-5 h-5" />
                            </button>
                        </PageDialogClose>
                    </PageDialogHeader>
                    <div className="px-6 mt-5">
                        <CreditCard size={32} />
                        <div className="text-[20px] text-gray-black mt-[10px] font-medium mb-6">
                            Choose a payment method.
                        </div>
                        <div className="flex items-center gap-3 overflow-auto">
                            <Sheet>
                                <SheetTrigger asChild>
                                    <button className="min-w-[190px] h-[130px] w-full border-[0.6px] border-gray-900 flex flex-col items-center justify-center gap-2 text-gray-900 rounded-2xl hover:border-gradient">
                                        <Plus size={24} />
                                        <div className="text-[18px] font-medium">Add Payment Method</div>
                                    </button>
                                </SheetTrigger>
                                <SheetContent className="overflow-hidden" aria-describedby={undefined}>
                                    <SheetHeader className="justify-end">
                                        <SheetClose>
                                            <X className="w-5 h-5" />
                                        </SheetClose>
                                    </SheetHeader>
                                    세부사항
                                </SheetContent>
                            </Sheet>
                            <button className="min-w-[190px] h-[130px] w-full border-[0.6px] border-gray-900 flex flex-col items-center justify-center text-gray-900 rounded-2xl hover:border-gradient">
                                <CreditCard size={24} />
                                <div className="text-[18px] font-medium">카드명</div>
                            </button>
                            <button className="min-w-[190px] h-[130px] w-full border-[0.6px] border-gray-900 flex flex-col items-center justify-center text-gray-900 rounded-2xl hover:border-gradient">
                                <CreditCard size={24} />
                                <div className="text-[18px] font-medium">카드명</div>
                            </button>
                        </div>
                        <div className="mt-3 text-[15px] text-gray-500">
                            EurekaCodes does not store your credit card information.<br></br>
                            All information is managed by <span className="text-gray-600 font-semibold">Stripe.</span>
                        </div>
                        <Button size="lg" className="w-full mt-[54px]">
                            Completed
                        </Button>
                    </div>
                </div>
            </PageDialogContent>
        </PageDialog>
    );
};
